import classnames from 'clsx';
import React from 'react';
import { usePlaceholder } from '../../hooks/usePlaceholder';
import s from './TypewriterPlaceholder.scss';
export const TypewriterPlaceholder = _ref => {
  let placeholder = _ref.placeholder,
    query = _ref.query;
  const _usePlaceholder = usePlaceholder(placeholder, query),
    placeholders = _usePlaceholder.placeholders,
    currentPlaceholder = _usePlaceholder.currentPlaceholder,
    currentPlaceholderIndex = _usePlaceholder.currentPlaceholderIndex,
    typingDuration = _usePlaceholder.typingDuration,
    pauseDuration = _usePlaceholder.pauseDuration,
    deletingDuration = _usePlaceholder.deletingDuration,
    pauseBetweenDeletionsDuration = _usePlaceholder.pauseBetweenDeletionsDuration;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames({
      [s.typewriterPlaceholder]: !query
    }),
    "data-text": currentPlaceholder,
    "data-text-fallback": placeholders[0] ?? '',
    "data-is-cycling": placeholders.length > 1,
    key: currentPlaceholderIndex,
    style: {
      '--char-count': (currentPlaceholder == null ? void 0 : currentPlaceholder.length) || 20,
      '--typing-duration': `${typingDuration}ms`,
      '--pause-duration': `${pauseDuration}ms`,
      '--deleting-duration': `${deletingDuration}ms`,
      '--pause-between-deletions-duration': `${pauseBetweenDeletionsDuration}ms`
    }
  });
};
//# sourceMappingURL=TypewriterPlaceholder.js.map